import { Modal, Upload, Button, Space, message } from "antd";
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import service from "../../../@services";
import { getRequestHeader } from "../../../@utils/request.js";
import * as Utils from '../../../@utils';
import config from "../../../@config";
export default ({visible=false, taskType="", storeId="", storeCode='', close=()=>{}}) => {
    const fileNames = '线上销售库存批量导入模板'
    const onFileUploadSuccess = (file) => {
        if(!file||file.status!=="done") return
        service.inventory.upLoadOnline({
            fileName: fileNames,
            fileUrl: file.response.data,
            taskType: 3,
            businessContent: JSON.stringify({
                storeId: storeId,
                storeCode: storeCode,
                merchantId: "",
                merchantCode: ""
            })
        }).then((res)=>{
            message.success("导入数据成功")
        })
    }
    const downloadTemplate = () => {
        service.common.getFileTemplate({
            fileType: 'onlineStockTemplate'
        }).then((res)=>{
            Utils.download(res, fileNames+'.xlsx')
        })
    }

    return (
        <Modal
            title="批量添加"
            visible={visible}
            onCancel={close}
            footer={[
                <Button key="back" onClick={close}>关闭</Button>
            ]}
        >
            {
                <Space style={{display: "flex",justifyContent: "center", padding: "50px 0"}}>
                    <Upload
                        action={config.BASE_API+"/common/uploadFile"}
                        showUploadList={false}
                        headers={getRequestHeader()}
                        onChange={({file})=>onFileUploadSuccess(file)}
                    >
                        <Button type="primary" icon={<UploadOutlined />}>上传文件</Button>
                    </Upload>
                    <Button type="primary" icon={<DownloadOutlined />} onClick={downloadTemplate}>下载模版</Button>
                </Space>
            }
        </Modal>
    )
}
